<template>
    <div class="dynamic-button-message-editor w-100" :key="renderId">
        <div class="mb-2 w-100">
            <div class="mb-1" style="color: #475e7a; font-weight: 600">Data Source:</div>
            <TiptapEditor
                :placeholder="'Enter data source attribute'"
                :show-attributes="true"
                v-model="clone.dataSource"
                :whatsapp-mode="false"
                :allowed-attributes="allowedAttributes"
                :preview-mode="previewMode"
            />
        </div>

        <div class="button-editor-wrapper">
            <div class="text-editor-wrapper">
                <div class="text-editor">
                    <TiptapEditor
                        :placeholder="$t('chatbotv2.enterYourMessage')"
                        :show-attributes="showAttributes === undefined || showAttributes === true"
                        :show-emoji="showEmoji === undefined || showEmoji === true"
                        v-model="clone.message"
                        :max-character-count="640"
                        :whatsapp-mode="whatsappMode"
                        :allowed-attributes="allowedAttributes"
                        :preview-mode="previewMode"
                    />
                </div>
            </div>
            <div class="buttons-wrapper">
                <div class="button-item">
                    <a-popover
                        :visible="editingButtonPopupVisible"
                        placement="left"
                        @visibleChange="visibleChange"
                        trigger="click"
                        :overlayClassName="'no-padding'"
                    >
                        <div slot="content">
                            <ActionButtonUpdater
                                v-model="clone.buttonTemplate"
                                :on-completed="onButtonUpdateCompleted"
                                :popup-visible="editingButtonPopupVisible"
                                :flattedDiagram="flattedDiagram"
                                :whatsapp-mode="whatsappMode"
                                :allowed-attributes="allowedAttributes"
                                :dynamic-button-message-editor="true"
                                :allowedMessageTypes="['SEND_MESSAGE']"
                            />
                        </div>

                        <span class="d-flex justify-content-center align-items-center w-100 h-100">
                            {{ clone.buttonTemplate.title }}
                        </span>
                    </a-popover>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import ActionButtonUpdater from "../../common/ActionButtonUpdater";
import _ from "lodash";

const log = log2("DynamicButtonMessageEditor");
export default {
    name: "DynamicButtonMessageEditor",
    components: { TiptapEditor, ActionButtonUpdater },
    props: {
        value: {
            type: Object,
            required: true,
        },
        flattedDiagram: {
            type: Array,
            default: () => [],
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
        showEmoji: {
            type: Boolean,
            default: true,
        },
        showAttributes: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            editingButtonPopupVisible: false,
            renderId: 0,
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        visibleChange(visible) {
            const attributeFormIsEnabled = !!document.getElementById("add-custom-attr-modal");
            log("visibleChange", { visible, attributeFormIsEnabled });
            if (!visible && attributeFormIsEnabled) {
                return;
            }
            this.editingButtonPopupVisible = visible;
            this.renderId++;
        },
        onButtonUpdateCompleted() {
            this.editingButtonPopupVisible = false;
        },
        emitValue() {
            if (!_.isEqual(this.clone, this.value)) {
                log("emitValue", this.clone);
                this.$emit("input", this.clone);
            }
        },
    },
    watch: {
        value: {
            handler(val) {
                log("watch value-->", val);
                this.clone = _.cloneDeep(val);
            },
            deep: true,
        },
        clone: {
            handler(val) {
                log("watch clone-->", val);
                this.emitValue();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.dynamic-button-message-editor {
    box-sizing: border-box;
    margin: 0;
    outline: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    .editable-editor-wrapper {
        height: 90%;
    }

    .text-editor-wrapper {
        position: relative;
        user-select: auto;
        width: 100%;

        .text-editor {
            border-radius: 8px 8px 0px 0px;
            border: 1px solid #fff;
            overflow-x: hidden;
            overflow-y: auto;
            transition: border 0.3s;
            height: 150px;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
    .button-editor-wrapper {
        width: 240px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .buttons-wrapper {
        width: 100%;

        .button-item {
            align-items: center;
            cursor: pointer;
            display: flex;
            height: 42px;
            justify-content: center;
            padding: 0 10px;
            transition: all 0.3s;
            width: 100%;
            background: #fff;
            border-top: 1px solid #e6e6e6;
            position: relative;

            span {
                color: #006cff;
                font-size: 15px;
                font-weight: 600;
                line-height: 19px;
                overflow: hidden !important;
                text-overflow: ellipsis;
                text-align: center;
            }
        }
    }
}

.ProseMirror {
    color: #22272d;
    font-size: 16px;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale;
    font-family: Source Sans Pro, sans-serif;
    font-weight: 400;
}
</style>
